import { createCRUDHook } from './createCRUDHook';
import { checkListTemplateDto } from 'utils/models';
import {
  TBL_CHECKLIST_TEMPLATE,
  TBL_CHECKLIST_TEMPLATE_BY_PART_ID,
} from './apiEndPoints';

interface CheckListTemplateCustomOperations {
  getCheckListTemplateDataByPartId: (
    partId: number
  ) => Promise<checkListTemplateDto>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  checkListTemplateDto,
  checkListTemplateDto[],
  CheckListTemplateCustomOperations
>({
  entityName: 'CheckListTemplate',
  endpoint: TBL_CHECKLIST_TEMPLATE,

  customOperations: (auth) => ({
    getCheckListTemplateDataByPartId: async (
      partId: number
    ): Promise<checkListTemplateDto> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_CHECKLIST_TEMPLATE +
            TBL_CHECKLIST_TEMPLATE_BY_PART_ID +
            `/${partId}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const CheckListTemplateContext = Context;
export const useCheckListTemplateManager = useManager;
export const useCheckListTemplate = useConsumer;
